import { ORG_PALETTE, getOrgTokens } from "./organizationPalette";

export const variants = [
  {
    props: { variant: "Reuse Card" },
    style: ({ theme }) => {
      const tok = getOrgTokens(theme.palette.mode === "dark");
      return {
        borderWidth: 1,
        borderColor: tok.border.card,
        backgroundColor: tok.bg.card,
        borderRadius: ORG_PALETTE.radius.card,
        padding: 3,
        boxShadow: tok.shadow.card,
      };
    },
  },
  {
    props: { variant: "Graph Card" },
    style: ({ theme }) => {
      const tok = getOrgTokens(theme.palette.mode === "dark");
      return {
        borderWidth: 1,
        borderColor: tok.border.card,
        borderRadius: ORG_PALETTE.radius.card,
        minWidth: 400,
        backgroundColor: tok.bg.card,
        boxShadow: tok.shadow.card,
      };
    },
  },
  {
    props: { variant: "Table Container" },
    style: ({ theme }) => {
      const tok = getOrgTokens(theme.palette.mode === "dark");
      return {
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: tok.border.table,
        borderRadius: ORG_PALETTE.radius.table,
        overflow: "hidden",
        backgroundColor: tok.bg.card,
        boxShadow: tok.shadow.card,
      };
    },
  },
  {
    props: { variant: "Chart Container" },
    style: ({ theme }) => {
      const tok = getOrgTokens(theme.palette.mode === "dark");
      return {
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: tok.border.card,
        borderRadius: ORG_PALETTE.radius.card,
        overflow: "hidden",
        backgroundColor: tok.bg.card,
        padding: theme.spacing(3),
        boxShadow: tok.shadow.card,
      };
    },
  },
];
